import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './soc-as-a-service.css'

const SOCAsAService = (props) => {
  return (
    <div className="soc-as-a-service-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="SOC-as-a-Service - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/soc-as-a-service"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="soc-as-a-service-hero-section">
        <div className="hero-media-wrapper">
          <img
            alt="A cybersecurity expert in a dimly lit room is typing on a colorful keyboard with multiple screens displaying data."
            src="https://images.pexels.com/photos/5380594/pexels-photo-5380594.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-background-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content-wrapper">
          <div className="soc-as-a-service-hero-content">
            <div className="hero-text-block">
              <h1 className="hero-title soc-as-a-service-hero-title">
                Enterprise-Grade Security Operations Center as a Service
              </h1>
              <p className="soc-as-a-service-hero-subtitle hero-subtitle">
                24/7 threat monitoring, incident response, and digital forensics
                delivered by certified security experts. Protect your
                organization with continuous, proactive defense.
              </p>
              <div className="hero-trust-signals">
                <div className="trust-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                  <span>ISO 27001 Certified</span>
                </div>
                <div className="trust-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 6v6l4 2"></path>
                      <circle r="10" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                  <span>15-Minute Response SLA</span>
                </div>
                <div className="trust-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <path d="M12 8v4m0 4h.01"></path>
                    </g>
                  </svg>
                  <span>99.9% Uptime Guarantee</span>
                </div>
              </div>
              <div className="hero-cta-group soc-as-a-service-hero-cta-group">
                <a href="#contact">
                  
                    <a className="btn-primary btn btn-lg" href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled">
                      <span>Talk to an Expert</span>
                    </a>
                  
                </a>
                <a href="#assessment">
                  <div className="btn btn-lg btn-outline">
                    <span style={{ color: 'black' }}>Request Assessment</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="soc-as-a-service-features-section">
        <div className="features-container">
          <div className="features-header">
            <h2 className="section-title">Comprehensive SOC as a Service</h2>
            <p className="section-subtitle">
              End-to-end security operations capabilities delivered as a fully
              managed service. Our SOCaaS combines advanced technology with
              human expertise to provide continuous threat detection, rapid
              incident response, and proactive security management.
            </p>
          </div>
          <div className="soc-as-a-service-features-grid">
            <div className="soc-as-a-service-feature-card">
              <div className="soc-as-a-service-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-feature-title">
                24/7 Security Monitoring
              </h3>
              <p className="soc-as-a-service-feature-description">
                Round-the-clock surveillance of your IT infrastructure with
                real-time threat detection and alerting. Our security analysts
                monitor your environment continuously, ensuring no threat goes
                unnoticed.
              </p>
            </div>
            <div className="soc-as-a-service-feature-card">
              <div className="soc-as-a-service-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-feature-title">
                Advanced Threat Intelligence
              </h3>
              <p className="soc-as-a-service-feature-description">
                Leverage global threat intelligence feeds and machine learning
                algorithms to identify emerging threats before they impact your
                organization. Stay ahead of sophisticated attackers with
                predictive analytics.
              </p>
            </div>
            <div className="soc-as-a-service-feature-card">
              <div className="soc-as-a-service-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="soc-as-a-service-feature-title">
                Rapid Incident Response
              </h3>
              <p className="soc-as-a-service-feature-description">
                Immediate containment and remediation of security incidents with
                our expert response team. Minimize damage and downtime with
                proven incident handling procedures and automated response
                playbooks.
              </p>
            </div>
            <div className="soc-as-a-service-feature-card">
              <div className="soc-as-a-service-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                    <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                    <path d="M3 12a9 3 0 0 0 18 0"></path>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-feature-title">
                Log Management &amp; Analysis
              </h3>
              <p className="soc-as-a-service-feature-description">
                Centralized collection, correlation, and analysis of security
                logs from all your systems. Gain visibility into security events
                and maintain compliance with retention requirements.
              </p>
            </div>
            <div className="soc-as-a-service-feature-card">
              <div className="soc-as-a-service-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="3" rx="2" width="20" height="14"></rect>
                    <path d="M8 21h8m-4-4v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-feature-title">
                Security Dashboard &amp; Reporting
              </h3>
              <p className="soc-as-a-service-feature-description">
                Access real-time security metrics through intuitive dashboards
                and receive comprehensive reports tailored to your stakeholders.
                Track KPIs, trends, and compliance status at a glance.
              </p>
            </div>
            <div className="soc-as-a-service-feature-card">
              <div className="soc-as-a-service-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle r="6" cx="12" cy="8"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-feature-title">
                Compliance Management
              </h3>
              <p className="soc-as-a-service-feature-description">
                Maintain compliance with industry regulations including PCI-DSS,
                HIPAA, GDPR, and SOC 2. Our SOCaaS platform provides continuous
                monitoring and automated compliance reporting capabilities.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="process-deployment-section">
        <div className="process-container">
          <div className="process-header">
            <h2 className="section-title">
              Solution Deployment &amp; Maintenance
            </h2>
            <p className="section-subtitle">
              Our proven deployment methodology ensures seamless integration
              with your existing infrastructure and ongoing operational
              excellence through continuous maintenance and optimization.
            </p>
          </div>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number-wrapper">
                <span className="step-number">01</span>
                <div className="step-connector"></div>
              </div>
              <div className="step-content">
                <div className="step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m21 21l-4.34-4.34"></path>
                      <circle r="8" cx="11" cy="11"></circle>
                    </g>
                  </svg>
                </div>
                <h3 className="step-title">Discovery &amp; Assessment</h3>
                <p className="step-description">
                  Comprehensive analysis of your current security posture,
                  infrastructure, and requirements. We identify integration
                  points, security gaps, and prioritize deployment phases based
                  on risk and business impact.
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number-wrapper">
                <span className="step-number">02</span>
                <div className="step-connector"></div>
              </div>
              <div className="step-content">
                <div className="step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="3"
                        y="11"
                        rx="2"
                        ry="2"
                        width="18"
                        height="11"
                      ></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="step-title">Platform Configuration</h3>
                <p className="step-description">
                  Custom configuration of SIEM, EDR, and security tools tailored
                  to your environment. We establish log sources, correlation
                  rules, detection algorithms, and integrate with your existing
                  security stack for unified visibility.
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number-wrapper">
                <span className="step-number">03</span>
                <div className="step-connector"></div>
              </div>
              <div className="step-content">
                <div className="step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="step-title">Testing &amp; Validation</h3>
                <p className="step-description">
                  Rigorous testing of all monitoring capabilities, alert
                  mechanisms, and response procedures. We simulate security
                  events to validate detection accuracy, response times, and
                  escalation workflows before going live.
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number-wrapper">
                <span className="step-number">04</span>
                <div className="step-connector"></div>
              </div>
              <div className="step-content">
                <div className="step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="2" y="3" rx="2" width="20" height="14"></rect>
                      <path d="M8 21h8m-4-4v4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="step-title">Go-Live &amp; Stabilization</h3>
                <p className="step-description">
                  Phased activation of monitoring services with enhanced support
                  during the initial period. Our team provides dedicated
                  attention to fine-tune detection rules, reduce false
                  positives, and optimize system performance.
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number-wrapper">
                <span className="step-number">05</span>
              </div>
              <div className="step-content">
                <div className="step-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="step-title">Continuous Optimization</h3>
                <p className="step-description">
                  Ongoing tuning and enhancement of security controls based on
                  threat landscape changes, new vulnerabilities, and emerging
                  attack patterns. Regular reviews ensure your SOC capabilities
                  evolve with your business and threat environment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    
      <section className="services-managed-section">
        <div className="services-container">
          <div className="services-header">
            <h2 className="section-title">Managed Security Services</h2>
            <p className="section-subtitle">
              Comprehensive security service portfolio delivering continuous
              protection through advanced monitoring, proactive threat hunting,
              and expert security guidance.
            </p>
          </div>
          <div className="soc-as-a-service-services-grid">
            <div className="soc-as-a-service-service-card">
              <div className="soc-as-a-service-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M2.062 12.348a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 19.876 0a1 1 0 0 1 0 .696a10.75 10.75 0 0 1-19.876 0"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-service-title">
                Continuous Security Monitoring
              </h3>
              <p className="soc-as-a-service-service-description">
                24/7/365 monitoring of security events across your entire
                infrastructure. Our global SOC provides uninterrupted
                surveillance with immediate alert response and escalation to
                ensure continuous protection against emerging threats.
              </p>
            </div>
            <div className="soc-as-a-service-service-card">
              <div className="soc-as-a-service-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m21 21l-4.34-4.34"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-service-title">
                Proactive Threat Hunting
              </h3>
              <p className="soc-as-a-service-service-description">
                Expert-led threat hunting operations to identify hidden threats
                and advanced persistent threats that evade automated detection.
                Our hunters use intelligence-driven hypotheses and behavioral
                analytics to find sophisticated attackers.
              </p>
            </div>
            <div className="soc-as-a-service-service-card">
              <div className="soc-as-a-service-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-service-title">
                Vulnerability Management
              </h3>
              <p className="soc-as-a-service-service-description">
                Continuous scanning and assessment of your systems to identify
                vulnerabilities before attackers exploit them. We prioritize
                findings based on risk and provide remediation guidance aligned
                with your business context.
              </p>
            </div>
            <div className="soc-as-a-service-service-card">
              <div className="soc-as-a-service-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                    <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                    <path d="M3 12a9 3 0 0 0 18 0"></path>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-service-title">
                Threat Intelligence Integration
              </h3>
              <p className="soc-as-a-service-service-description">
                Real-time integration of global threat intelligence feeds
                customized to your industry and threat landscape. We transform
                raw intelligence into actionable insights that strengthen your
                security posture and detection capabilities.
              </p>
            </div>
            <div className="soc-as-a-service-service-card">
              <div className="soc-as-a-service-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="3" rx="2" width="20" height="14"></rect>
                    <path d="M8 21h8m-4-4v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-service-title">
                Security Orchestration &amp; Automation
              </h3>
              <p className="soc-as-a-service-service-description">
                Automated response playbooks and orchestration workflows that
                accelerate incident response and reduce analyst workload. We
                integrate your security tools for coordinated, efficient threat
                mitigation at machine speed.
              </p>
            </div>
            <div className="soc-as-a-service-service-card">
              <div className="soc-as-a-service-service-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle r="6" cx="12" cy="8"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="soc-as-a-service-service-title">
                Compliance Support &amp; Reporting
              </h3>
              <p className="soc-as-a-service-service-description">
                Continuous monitoring and reporting aligned with regulatory
                requirements including PCI-DSS, HIPAA, GDPR, and SOC 2. We
                provide audit-ready documentation and assist with compliance
                assessments and certification processes.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="soc-as-a-service-thq-stats-compliance-section-elm stats-compliance-section">
        <div className="stats-container">
          <div className="stats-header">
            <h2 className="section-title">
              Industry-Leading Certifications &amp; Standards
            </h2>
            <p className="section-subtitle">
              Our SOCaaS platform and operations are certified against the most
              rigorous international security standards, ensuring your
              organization receives enterprise-grade protection and compliance
              support.
            </p>
          </div>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="stat-title">ISO 27001</h3>
              <p className="stat-description">
                Certified Information Security Management System demonstrating
                our commitment to protecting customer data through systematic
                risk management and continuous improvement processes.
              </p>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="stat-title">SOC 2 Type II</h3>
              <p className="stat-description">
                Independently audited controls for security, availability,
                processing integrity, confidentiality, and privacy. Our SOC 2
                compliance ensures trust and transparency in our service
                delivery.
              </p>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="stat-title">PCI-DSS</h3>
              <p className="stat-description">
                Payment Card Industry Data Security Standard compliance for
                organizations processing, storing, or transmitting cardholder
                data. We help maintain continuous compliance with all twelve
                requirements.
              </p>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="stat-title">GDPR Ready</h3>
              <p className="stat-description">
                Data protection capabilities aligned with General Data
                Protection Regulation requirements. We support data privacy
                obligations including breach notification, data subject rights,
                and privacy by design.
              </p>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                    <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                    <path d="M3 12a9 3 0 0 0 18 0"></path>
                  </g>
                </svg>
              </div>
              <h3 className="stat-title">HIPAA Compliant</h3>
              <p className="stat-description">
                Healthcare industry security and privacy controls meeting HIPAA
                requirements for Protected Health Information. Our SOCaaS
                supports healthcare organizations in maintaining compliance and
                protecting patient data.
              </p>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle r="6" cx="12" cy="8"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="stat-title">NIST Framework</h3>
              <p className="stat-description">
                Aligned with NIST Cybersecurity Framework providing
                comprehensive coverage across Identify, Protect, Detect,
                Respond, and Recover functions for holistic security management.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="soc-as-a-service-container2">
        <div className="soc-as-a-service-container3">
          <Script
            html={`<script defer data-name="testimonials-scroll">
(function(){
  const testimonialsRail = document.querySelector(".testimonials-rail")

  if (testimonialsRail) {
    let isDown = false
    let startX
    let scrollLeft

    testimonialsRail.addEventListener("mousedown", (e) => {
      isDown = true
      testimonialsRail.style.cursor = "grabbing"
      startX = e.pageX - testimonialsRail.offsetLeft
      scrollLeft = testimonialsRail.scrollLeft
    })

    testimonialsRail.addEventListener("mouseleave", () => {
      isDown = false
      testimonialsRail.style.cursor = "grab"
    })

    testimonialsRail.addEventListener("mouseup", () => {
      isDown = false
      testimonialsRail.style.cursor = "grab"
    })

    testimonialsRail.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - testimonialsRail.offsetLeft
      const walk = (x - startX) * 2
      testimonialsRail.scrollLeft = scrollLeft - walk
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <section className="soc-as-a-service-thq-cta-section-elm soc-as-a-service-cta-section">
        <div className="soc-as-a-service-cta-wrapper">
          <div className="cta-content-left">
            <div className="cta-text-block">
              <h2 className="section-title">
                Ready to Elevate Your Security Operations?
              </h2>
              <p className="section-content">
                Partner with Cysigil Security to access enterprise-grade security
                operations capabilities without the overhead of building an
                in-house SOC. Our experts are ready to design a customized
                SOCaaS solution tailored to your organization&apos;s unique
                requirements and threat landscape.
              </p>
              <a href="#contact">
                
                  <a className="btn-primary btn btn-lg" href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled">
                    <span>Talk to an Expert</span>
                  </a>
                
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </div>
  )
}

export default SOCAsAService
